import { WhatsAppQrConnectDialog } from "@/components/integrations/WhatsAppQrConnectDialog";

interface EvolutionApiDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  existingIntegration?: any;
  reconnectMode?: boolean;
}

export function EvolutionApiDialog({
  open,
  onOpenChange,
  existingIntegration,
  reconnectMode,
}: EvolutionApiDialogProps) {
  return (
    <WhatsAppQrConnectDialog
      open={open}
      onOpenChange={onOpenChange}
      provider="whatsapp_evolution"
      edgeFunction="evolution-connect"
      title="Conectar WhatsApp"
      description="Escaneie o QR code para conectar sua conta WhatsApp"
      existingIntegration={existingIntegration}
      reconnectMode={reconnectMode}
    />
  );
}
